import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getRootClasses = (checked) => {
  const classes = [
    "relative",
    "dsf-text-s",
    "flex-auto",
    "flex",
    "items-center",
    "justify-center",
    "gap-8",
    "h-32",
    "p-8",
    "min-w-140",
    "cursor-pointer",
    "border"
  ];
  classes.push(checked ? "text-neutral-0" : "text-neutral-400");
  classes.push(checked ? "border-secondary-300" : "border-neutral-50");
  classes.push(checked ? "bg-secondary-300" : "bg-neutral-50");
  classes.push(checked ? "hover:bg-secondary-400" : "hover:bg-neutral-100");
  classes.push(
    checked ? "focus-within:border-secondary-400" : "focus-within:border-neutral-200 focus-within:bg-neutral-100"
  );
  return concatClasses(classes);
};
export {
  getRootClasses
};
